"use client";

import { useEffect } from "react";

export function HtmlDirSetter({ locale }: { locale: string }) {
  useEffect(() => {
    const html = document.documentElement;
    const isArabic = locale === "ar";

    html.lang = locale;
    html.dir = isArabic ? "rtl" : "ltr";

    if (isArabic) {
      // Read the Changa font value loaded by Next.js into --font-cairo,
      // then inject it as an inline-style override on --font-syne and
      // --font-inter. Inline styles beat CSS Modules classes (which set
      // these vars for Orbitron/Exo2), so Changa always wins in Arabic.
      const changaFont = getComputedStyle(html)
        .getPropertyValue("--font-cairo")
        .trim();

      if (changaFont) {
        html.style.setProperty("--font-syne", changaFont);
        html.style.setProperty("--font-inter", changaFont);
      }
    } else {
      // Restore default fonts when switching back to English
      html.style.removeProperty("--font-syne");
      html.style.removeProperty("--font-inter");
    }
  }, [locale]);

  return null;
}
